<template>
    <DFormRow
        :label="__('customers.contracts.contract_group')"
        :error="errors.contract_group"
    >
        <DInput
            id="contract_group"
            list="existing_contract_groups"
            :model-value="modelValue"
            @update:modelValue="$emit('update:modelValue', $event)"
        />
        <datalist id="existing_contract_groups">
            <option
                v-for="contractGroup in existingContractGroups"
                :key="contractGroup"
                :value="contractGroup"
            />
        </datalist>
    </DFormRow>
</template>

<script setup>
defineProps({
    modelValue: {
        type: [String, Number],
        default: null
    },
    errors: {
        type: Object,
        default: () => { return {} }
    },
    existingContractGroups: {
        type: Array,
        default: () => { return [] }
    }
})

defineEmits(['update:modelValue'])
</script>
